import React, { useEffect, useState, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
} from "@mui/x-data-grid-pro";
import dayjs from "dayjs";
import { MdDelete, MdContentCopy } from "react-icons/md";
import { marked } from "marked";

import api from "../../../services/api";
import Loading from "../../../components/Loader/Loading";
import MUIDataTable from "../../../components/MUIGrid";
import { Modal } from "../../../components";
import CustomBreadcrumbs from "../../../components/common/CustomBreadcrumbs";
import { Button } from "@mui/material";
import { FaSearch } from "react-icons/fa";
const BlogPreview = ({ title, description, metaDescription, metaHeading }) => (
  <div className="p-4 space-y-4">
    {metaHeading && <h1 className="text-2xl font-bold">{metaHeading}</h1>}
    {title && <h2 className="text-xl font-semibold">{title}</h2>}
    {metaDescription && <p className="text-gray-700">{metaDescription}</p>}
    {description && (
      <div
        className="prose max-w-none"
        dangerouslySetInnerHTML={{ __html: marked(description) }}
      />
    )}
  </div>
);
export default function Merchants() {
  const [domainBlogs, setDomainBlogs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isDataModal, setDataModal] = useState(false);
  const [logsData, setLogsData] = useState("");
  const [users, setUsers] = useState([]);
  const cancelButtonRef = useRef(false);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 100,
    page: 1,
  });
  const [queryOptions, setQueryOptions] = React.useState({
    groupOp: "",
    rules: [],
  });
  const handleDataModal = () => {
    setDataModal(!isDataModal);
  };
  const fetchDomainBlogs = async (filter) => {
    setIsLoading(true);
    try {
      const response = await api.post(
        `${process.env.REACT_APP_PUBLIC_API}/api/domains/domain_blog`,
        filter
      );
      setDomainBlogs(response.data);
    } catch (error) {
      console.error(`Error fetching users data: ${error}`);
    }
    setIsLoading(false);
  };

  const get_user = async () => {
    const filters = {
      groupOp: "AND",
      rules: [{ field: "is_active", op: "eq", data: 1 }],
    };
    try {
      const res = await api.post("/api/users/users_report", {
        filters,
        page: 1,
        perPage: 1000,
      });
      if (res.status === 200) {
        setUsers(res.data?.records);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchDomainBlogs({
      page: paginationModel?.page,
      pageSize: paginationModel?.pageSize,
      filters: queryOptions,
    });
    get_user();
  }, []);
  const handleNewFilter = () => {
    setPaginationModel({ pageSize: paginationModel.pageSize, page: 1 });
    fetchDomainBlogs({
      filters: queryOptions,
      page: 1,
      pageSize: paginationModel.pageSize,
    });
  };
  function CustomToolbar({ setFilterButtonEl }) {
    return (
      <GridToolbarContainer className="mb-3 mt-3 flex items-center justify-between">
        <div className="flex">
          <GridToolbarColumnsButton
            sx={{
              borderRadius: "6px",
              marginRight: "4px",
              border: "1px solid",
              borderColor: "#e8eaee",
              height: "26px",
              paddingLeft: 1,
              paddingRight: 1,
            }}
          />
          <GridToolbarDensitySelector
            sx={{
              borderRadius: "6px",
              marginRight: "4px",
              border: "1px solid",
              borderColor: "#e8eaee",
              height: "26px",
              paddingLeft: 1,
              paddingRight: 1,
            }}
          />
          <GridToolbarFilterButton
            sx={{
              borderRadius: "6px",
              marginRight: "4px",
              border: "1px solid",
              borderColor: "#e8eaee",
              height: "26px",
              paddingLeft: 1,
              paddingRight: 1,
            }}
            ref={setFilterButtonEl}
          />
          <Button
            variant="text"
            onClick={handleNewFilter}
            startIcon={<FaSearch size={16} />}
            sx={{
              borderRadius: "6px",
              marginRight: "4px",
              border: "1px solid",
              borderColor: "#e8eaee",
              height: "26px",
              fontSize: "0.8125rem",
              paddingLeft: 1,
              paddingRight: 1,
            }}
            // className="!text-[#042a42]"
          >
            Apply filter
          </Button>
        </div>
      </GridToolbarContainer>
    );
  }
  const columnDefs = [
    {
      headerName: "Sr#",
      field: "counter",
      width: 10,
      filterable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <div className="p-4 min-h-[120px] flex items-center justify-center">
          {params?.row?.counter}
        </div>
      ),
    },
    {
      headerName: "Domain",
      field: "db.domain",
      minWidth: 280,
      renderCell: (params) => (
        <div className="p-4 min-h-[120px] flex items-center">
          <a
            href={`https://www.${params.row["db.domain"]}`}
            className="hover:text-secondary underline truncate block w-full"
            target="_blank"
            rel="noreferrer"
            title={params.row["db.domain"]}
          >
            {params.row["db.domain"]}
          </a>
        </div>
      ),
    },
    {
      field: "u.id",
      headerName: "User",
      minWidth: 250,
      type: "singleSelect",
      getOptionValue: (value) => value?.id,
      getOptionLabel: (value) => value.name,
      valueOptions: users,
      valueGetter: (params) => params.row?.["u.id"],
      valueFormatter: (params) => {
        const user = users.find((user) => user.id === params.value);
        return user ? user.name : "";
      },
      renderCell: (params) => (
        <div className="p-4 min-h-[120px] flex items-center">
          {params?.row?.["u.name"]}
        </div>
      ),
    },
    {
      headerName: "Blog",
      field: "db.blog",
      filterable: false,
      minWidth: 400,
      flex: 1,
      renderCell: (params) => {
        const blogData = params?.row["db.blog"];
        let parsedBlog = blogData;

        // Try to parse blog data if it's a string
        if (typeof blogData === "string") {
          try {
            parsedBlog = JSON.parse(blogData);
          } catch (e) {
            // If not JSON, use as is
            parsedBlog = blogData;
          }
        }

        const metaTitle =
          parsedBlog?.meta_title || parsedBlog?.meta_heading || "No Title";
        const metaDescription = parsedBlog?.meta_description || "";
        const description = parsedBlog?.description || "";

        // Get preview text (first 200 characters)
        const previewText = metaDescription || description || "";
        const truncatedText =
          previewText.length > 150
            ? previewText.substring(0, 150) + "..."
            : previewText;

        return (
          <div className="p-4 w-full min-h-[120px] flex flex-col justify-start">
            <h4
              className="font-semibold text-sm mb-1 line-clamp-2"
              title={metaTitle}
            >
              {metaTitle}
            </h4>
            {truncatedText && (
              <p
                className="text-xs text-gray-600 mb-1 line-clamp-4"
                title={previewText}
              >
                {truncatedText}
              </p>
            )}
            <button
              onClick={(e) => openDataModal(blogData)}
              className="inline-flex items-center gap-1 text-sm font-medium text-blue-600 bg-blue-50 hover:bg-blue-100 hover:border-blue-300 hover:text-blue-700 transition-all duration-200 focus:outline-none"
              title="Read full blog content"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                />
              </svg>
              Read more
            </button>
          </div>
        );
      },
    },
    {
      field: "db.image_url",
      headerName: "Image",
      filterable: false,
      minWidth: 250,
      renderCell: (params) => {
        const imageUrl = params?.row["db.image_url"];

        const copyToClipboard = (text) => {
          navigator.clipboard
            .writeText(text)
            .then(() => {
              toast.success("URL copied to clipboard!");
            })
            .catch(() => {
              toast.error("Failed to copy URL");
            });
        };

        return (
          <div className="p-4 flex items-center gap-3 min-h-[120px]">
            {imageUrl && (
              <>
                <img
                  src={imageUrl}
                  alt="Blog thumbnail"
                  className="w-20 h-20 object-cover rounded-lg border"
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
                <button
                  onClick={(e) => copyToClipboard(imageUrl)}
                  className="inline-flex items-center gap-1 text-xs text-gray-600 hover:text-gray-800 p-2 rounded hover:bg-gray-100"
                  title="Copy image URL"
                >
                  <MdContentCopy className="w-4 h-4" />
                </button>
              </>
            )}
          </div>
        );
      },
    },
    {
      field: "db.created_at",
      headerName: "Created At",
      filterable: false,
      minWidth: 250,
      renderCell: (params) => (
        <div className="whitespace-nowrap p-4 min-h-[120px] flex items-center">
          {params?.row?.["db.created_at"]}
        </div>
      ),
    },
    {
      headerName: "Actions",
      field: "action",
      width: 100,
      filterable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <div className="relative p-4 min-h-[120px] flex items-center justify-center">
          <div className="flex items-center justify-center">
            <MdDelete
              className="h-5 cursor-pointer text-black-400 ml-1"
              title="Delete Domain Blog"
              onClick={(e) => deleteDomainBlog(params.row["db.id"])}
              size={20}
            />
          </div>
        </div>
      ),
    },
  ];

  const deleteDomainBlog = (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this record?"
    );
    if (!isConfirmed) return;
    api
      .delete(`/api/domains/domain_blog/${id}`)
      .then((res) => {
        toast.success("Domain Blog Removed Successfully.");
        fetchDomainBlogs({
          filters: queryOptions,
          page: paginationModel?.page,
          pageSize: paginationModel.pageSize,
        });
      })
      .catch((err) => toast.error(err.response.data.message));
  };

  const openDataModal = async (blog) => {
    try {
      // Check if blog is a string that might be JSON
      let formattedBlog = blog;
      if (typeof blog === "string") {
        try {
          // Try to parse if it's a JSON string
          formattedBlog = JSON.parse(blog);
        } catch (e) {
          // If not JSON, use as is
          formattedBlog = blog;
        }
      }
      setLogsData(formattedBlog);
      setDataModal(true);
    } catch (error) {
      console.error("Error parsing blog data:", error);
      setLogsData("Error loading blog content");
      setDataModal(false);
    }
  };

  const offset = (paginationModel?.page - 1) * paginationModel?.pageSize;
  const dataRows = (domainBlogs?.data || []).map((record, index) => {
    const counter = offset + index + 1;
    const {
      summary,
      task_id: taskid,
      task_status,
      "db.id": dbid,
      "u.name": user_name,
      "db.domain": db_domain,
      "db.image_url": db_image_url,
      "db.created_at": db_created_at,
      "db.blog": db_blog,
    } = record;

    return {
      counter,
      taskid,
      summary,
      task_status,
      "db.id": dbid,
      "u.name": user_name,
      "db.domain": db_domain,
      "db.image_url": db_image_url,
      "db.created_at": dayjs(db_created_at).format("ddd, MMM D, YYYY h:mm A"),
      "db.blog": db_blog,
    };
  });

  const handlePageSizeChange = (newPageSize) => {
    console.log("🚀 ~ handlePageSizeChange ~ newPageSize:", newPageSize);
    setPaginationModel({ ...paginationModel, pageSize: newPageSize });
  };
  const handlePageChange = (params) => {
    setPaginationModel({ pageSize: params.pageSize, page: params.page + 1 });
    fetchDomainBlogs({
      filters: queryOptions,
      page: params.page + 1,
      pageSize: params.pageSize,
    });
  };
  const getRowHeight = () => {
    const rowHeight = 100;
    return rowHeight;
  };
  const onFilterChange = React.useCallback((filterModel) => {
    let ruless = [];
    if (filterModel?.items?.length === 0) {
      fetchDomainBlogs({
        page: 1,
        pageSize: paginationModel.pageSize,
      });
    }
    // eslint-disable-next-line array-callback-return
    filterModel.items?.map((rule) => {
      ruless = [
        ...ruless,
        {
          field: `${rule.field}`,
          op:
            rule.operator === "contains"
              ? "cn"
              : rule.operator === "equals"
              ? "eq"
              : rule.operator === "is"
              ? "eq"
              : rule.operator === "="
              ? "eq"
              : rule.operator === "!="
              ? "not"
              : rule.operator === ">"
              ? "gt"
              : rule.operator === ">="
              ? "gte"
              : rule.operator === "<"
              ? "lt"
              : rule.operator === "<="
              ? "lte"
              : rule.operator,
          // data: rule.value ? rule.value : null,
          data:
            rule.field === "latest_position"
              ? +rule.value
              : rule.operator === "isAnyOf" && rule.value[0]?.includes(",")
              ? rule.value[0].split(",").map((item) => item.trim())
              : rule.value
              ? rule.value
              : rule.value === 0
              ? rule.value
              : null,
        },
      ];
    });
    // ?.toLowerCase()?.includes(searchInput?.toLowerCase())
    setQueryOptions({
      groupOp: filterModel.logicOperator.toUpperCase(),
      rules: ruless,
    });
  }, []);
  return (
    <div className="px-6 pt-4">
      <CustomBreadcrumbs
        crumbs={[
          { label: "Home", link: "/" },
          { label: "Domain Blogs ", link: "" },
        ]}
      />
      <ToastContainer />
      {isLoading && <Loading />}
      <div className="bg-white my-3 border rounded">
        <MUIDataTable
          columnDefs={columnDefs}
          items={dataRows}
          CustomToolbar={CustomToolbar}
          height="88vh"
          searchable="No"
          showCount="No"
          totalItems={domainBlogs?.totalCount}
          paginationModel={paginationModel}
          onPaginationModelChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          gridOptions={getRowHeight}
          onFilterModelChange={onFilterChange}
        />
      </div>
      <Modal
        open={!isDataModal}
        handleModal={handleDataModal}
        cancelButtonRef={cancelButtonRef}
        className="max-w-3xl"
        title="Blog Content"
      >
        <div className="mt-4 max-h-[400px] overflow-y-auto">
          {typeof logsData === "string" ? (
            <div className="p-4">
              <div
                className="prose max-w-none"
                dangerouslySetInnerHTML={{ __html: marked(logsData) }}
              />
            </div>
          ) : logsData && typeof logsData === "object" ? (
            <BlogPreview
              title={logsData?.title}
              description={logsData?.description}
              metaDescription={logsData?.meta_description}
              metaHeading={logsData?.meta_heading}
            />
          ) : (
            <div className="whitespace-pre-wrap p-4 bg-gray-50 rounded-md">
              {logsData || "No content available"}
            </div>
          )}
        </div>
        <div className="mt-6 flex justify-end">
          <button
            type="button"
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            onClick={handleDataModal}
          >
            Close
          </button>
        </div>
      </Modal>
    </div>
  );
}
